const apolipoproteinMeasureType = {
  MilligramsPerDeciliter: 1,
  NanomolesPerLitre: 2
}

export default apolipoproteinMeasureType;